import React from "react";
import { DateBox, SelectBox, TagBox, Button } from "devextreme-react";
import { getDefaultLang } from "../../utils";
import { useAuth } from "../../context/authContext";

const dateRanges = [
  "today",
  "current week",
  "current month",
  "current year",
  "yesterday",
  "last week",
  "last month",
  "last year",
  "last 15 days",
  "last 30 days",
  "last 60 days",
  "last 90 days",
];

const PNPSalesReport = ({
  formData,
  handleSubmit,
  onValueChanged,
  isExporting,
}) => {
  const { activeLanguages, configParams, orderedWarehouses } = useAuth();

  const defaultAccountLang = getDefaultLang(
    configParams.default_language,
    activeLanguages
  );

  return (
    <div className='mt-4'>
      <form onSubmit={handleSubmit}>
        <div className='row'>
          <div className='col-4 mb-3'>
            <span className='sub-title text-capitalize'>Start Date *</span>

            <DateBox
              type='date'
              showClearButton={true}
              pickerType='calendar'
              value={formData.unixTimeStart}
              onValueChanged={(e) => onValueChanged(e, "unixTimeStart")}
              displayFormat={"EEEE, dd MMM, yyyy"}
            />
          </div>
          <div className='col-4 mb-3'>
            <span className='sub-title text-capitalize'>End Date *</span>
            <DateBox
              type='date'
              showClearButton={true}
              pickerType='calendar'
              value={formData.unixTimeEnd}
              onValueChanged={(e) => onValueChanged(e, "unixTimeEnd")}
              displayFormat={"EEEE, dd MMM, yyyy"}
            />
          </div>
          <div className='col-4 mt-4 mb-3'>
            <SelectBox
              dataSource={dateRanges}
              showClearButton={true}
              searchEnabled={true}
              placeholder='date range selector'
              value={formData.dateRange}
              onValueChanged={(e) => onValueChanged(e, "dateRange")}
            />
          </div>

          <div className='col-8 mb-3'>
            <span className='sub-title text-capitalize'>Locations *</span>
            <TagBox
              showClearButton={true}
              dataSource={orderedWarehouses}
              displayExpr={defaultAccountLang}
              showSelectionControls
              valueExpr='id'
              placeholder='select location'
              searchEnabled={true}
              showDropDownButton={true}
              selectAllMode='allPages'
              maxDisplayedTags={10}
              value={formData.warehouseIds}
              onValueChanged={(e) => onValueChanged(e, "warehouseIds")}
            />
          </div>
        </div>
        <Button
          useSubmitBehavior={true}
          className='mt-3'
          stylingMode='contained'
          type='default'
          text='Get report'
          disabled={isExporting}
          elementAttr={{ style: "background-color: #0737a0" }}
        />
      </form>
    </div>
  );
};

export default PNPSalesReport;
